module.exports = "<div class=\"cmss-window\">\n    <div class=\"cmss-container\">\n        <dbm-list [listTitle]=\"'CMS List'\" [listAction]=\"'Add CMS'\" [listItems]=\"cmss\" (onActionClick)=\"addCms()\"\n            (onListItemClick)=\"getCms($event.selectedItem, $event.indexInList)\" [disableFinishRender]=\"ifTest\"></dbm-list>\n    </div>\n    <cms-item [cms]=\"cms\" (onDelete)=\"delete()\" (onTest)=\"test($event)\" (onCancel)=\"onCancel($event)\"></cms-item>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/cms-management/cms-management.component.html
// module id = 1730
// module chunks = 0